module.exports = __webpack_public_path__ + "img/cover.9c4e11f9.jpg";